import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=bd5ca2d8"
import script from "@/controllers/ap/login/Reset?vue&type=script&lang=ts&external"
export * from "@/controllers/ap/login/Reset?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports